export default __webpack_public_path__ + "static/media/xmas_deer.397e054a.svg";